import { CreateUseCaseDataTypes } from './types';

import axiosInstance from 'common/services/common/instance';

export const getListKnowledgeUseCasesService = async (params?: any) => {
  const res = await axiosInstance.get('knowledge-use-cases', { params });
  return res.data;
};

export const getUseCaseByIdService = async (id: number) => {
  const res = await axiosInstance.get(`knowledge-use-cases/${id}`);
  return res.data;
};

export const createUseCaseService = async (params: CreateUseCaseDataTypes)
  : Promise<{ id: number }> => {
  const payload = {
    name: params.name,
    description: params.description,
  };
  const res = await axiosInstance.post('knowledge-use-cases', payload);
  return res.data.data;
};

export const deleteUseCaseService = async (params: { ids: number[] }) => {
  const res = await axiosInstance.delete('knowledge-use-cases', { data: params });
  return res.data;
};

export const updateUseCaseService = async (id: number, params: CreateUseCaseDataTypes)
  : Promise<void> => {
  const payload = {
    name: params.name,
    description: params.description,
  };
  await axiosInstance.put(`knowledge-use-cases/${id}`, payload);
};

export const getUseCaseDocumentContentService = async (id: number)
  : Promise<any> => {
  const res = await axiosInstance.get(`use-cases/${id}/document-content`);
  return res.data.data;
};

export const getUseCaseDocumentsService = async (id: number, params?: any) => {
  const res = await axiosInstance.get(`knowledge-use-cases/${id}/documents`, { params });
  return res.data;
};

export const getUseCaseDocumentDetailService = async (useCaseId: number, documentId: number) => {
  const res = await axiosInstance.get(`knowledge-use-cases/${useCaseId}/documents/${documentId}`);
  return res.data;
};

export const deleteUseCaseDocumentsService = async (
  useCaseId: number,
  params: { ids: number[] }
) => {
  const res = await axiosInstance.delete(
    `knowledge-use-cases/${useCaseId}/documents`,
    { data: params }
  );
  return res.data;
};

export const getUseCaseDocumentEmbeddingService = async (
  useCaseId: number,
  documentId: number
) => {
  const res = await axiosInstance.get(
    `knowledge-use-cases/${useCaseId}/documents/${documentId}/view-embedding-content`
  );
  return res.data;
};

export const getUseCaseDocumentViewContentService = async (
  useCaseId: number,
  documentId: number
) => {
  const res = await axiosInstance.get(
    `knowledge-use-cases/${useCaseId}/documents/${documentId}/view-content`
  );
  return res.data;
};

export const getUseCaseTrainingContentService = async (id: number)
  : Promise<any> => {
  const res = await axiosInstance.get(`use-cases/${id}/training-content`);
  return res.data.data;
};

export const updateUseCaseStatusService = async (id: number, status: number) => {
  const res = await axiosInstance.put(`knowledge-use-cases/${id}/update-status`, { status });
  return res.data;
};

export const retrainDocumentService = async (useCaseId: number, documentId: number) => {
  const res = await axiosInstance.post(
    `knowledge-use-cases/${useCaseId}/documents/${documentId}/re-train`
  );
  return res.data;
};
